// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"36fd9a9b","41":"52961a77","65":"f977aced","457":"c0c3be32","484":"52961a77","551":"c0c3be32","667":"c0c3be32","692":"026e3ecc","834":"6ac57307","961":"805e142a"}[chunkId] + ".chunk.css";
};